import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FileManagerComponent } from "../../shared/file-manager/containers/file-manager/file-manager.component";

import { Notice } from "../../../@core/models/notice.model";
import { NoticeService } from "../../../@core/services/notice.service";

import { NoticeItemService } from "../../../@core/services/notice-item.service";

declare var $: any;

import Swal from "sweetalert2";
import { EnvironmentsService } from "app/services/environments/environments.service";
import { GalleryService } from "app/services/gallery/gallery.service";

import { EditalTypeService } from "app/services/edital/edital-type.service";
import { Global } from "app/@core/lib/global";
import { ClientService } from "app/@core/services/client.service";

@Component({
  selector: "app-edital-items",
  templateUrl: "./items.component.html",
  styleUrls: ["../edital.component.scss"],
  providers: [NoticeItemService, NoticeService, EnvironmentsService, GalleryService, EditalTypeService, ClientService],
})
export class ItemsComponent implements OnInit {

  private id: number;

  public noticeItemsArray;
  public noticeItemForm: FormGroup;
  public noticeItemSelected;
  public orderList: "a-z" | "z-a" | "data";
  public inputSearch: string;
  public substr: any;
  public appUrl: any;

  @ViewChild(FileManagerComponent) appFileManager: FileManagerComponent;
  @Output() modalEvent: EventEmitter<any> = new EventEmitter<any>();

  public imgField;
  public fileSelected;
  public enable = false;
  public notice: Notice;
  public environmentArray: any;
  public formStatus = false;
  public clientID: any;
  public type: string;

  constructor(
    public _noticeService: NoticeService,
    public _noticeItemService: NoticeItemService,
    public _environmentsService: EnvironmentsService,
    public router: Router,
    public route: ActivatedRoute,
    public builder: FormBuilder,
    public _GalleryService: GalleryService,
    public _editalTypeService: EditalTypeService,
    public global: Global,
    public clientService: ClientService
  ) {
    // arquivo 1
    // this.fileSelected = {
    //   banner: null,
    //   background: null,
    //   logoTop: null,
    //   logoBG: null,
    // };

    this.route.params.subscribe((params) => {
      this.id = +params["id"];
      this.getNotice();
    });

    this.noticeItemForm = builder.group({
      title: ["", Validators.required],
      description: ["", Validators.required],
      date_start: ["", Validators.required],
      date_end: ["", Validators.required],
      thumb: [null],
      dual: ['null']
    });

    this.clientID = localStorage.getItem('client') || sessionStorage.getItem('client');
  }

  ngOnInit() {
    this.getNoticeItems();
    this.checkIfAvaliador();
    this.getColor();
  }

  getColor() {
    this.clientService.getColor().subscribe((res) => {
      if (res && res.length) {
        if (res[0].config && res[0].config.appName) {
          this.appUrl = res[0].config;
        } else if (res[0].config) {
          this.appUrl = res[0].config;
        }
        if (this.appUrl && this.appUrl.url && this.appUrl.url.length > 0) {
          this.appUrl.url = this.appUrl.url.map(u => u ? u.replace(/^https?:\/\//, '').replace(/\/+$/, '') : u);
        }
      }
    });
  }

  checkIfAvaliador() {
    try {
      let user = this.global.loggedUser();
      let u = Array.isArray(user) ? user[0] : user;
      let userId = u ? u.id : null;
      let data = u;
      
      if (userId) {
         let permissionStr = sessionStorage.getItem('permission-' + userId);
         if (permissionStr) {
            let permission = JSON.parse(permissionStr);
            data = Array.isArray(permission.data) ? permission.data[0] : permission.data;
         }
      }
      
      if (data && data.extras && data.extras.length > 0) {
        let extrasValue = JSON.parse(data.extras[0].value);
        if (extrasValue.tipo === 'avaliador') {
          this.type = 'avaliador';
        }
      }
    } catch (e) {
       console.error("Erro ao checar tipo avaliador", e);
    }
  }
  getEnviroments(): void {
    this._environmentsService.getResource(this.id).subscribe((res) => {
      this.environmentArray = res.data;
    });
  }

  getPhoto(image) {
    this.noticeItemForm.get('thumb').setValue(image.path);
    this.fileSelected = {
      background: image.path
    };
  }


  save() {
    let result;
    const form = this.noticeItemForm.value;
    this.formStatus = true;
    if (this.id) {
      result = this._GalleryService.createResource(form, { router: this.id })
    } else {
      result = this._GalleryService.createResource(form)
    }
    result.subscribe(res => {
      this.formStatus = false;
      this.noticeItemForm.reset({ dual: 'null' });
      $('#criar-pasta').modal('hide');
      this.modalEvent.emit(res.data);
    }, err => {
      this.formStatus = false;
    });
  }

  getNotice(): void {
    this._noticeService.entity(this.id).then((res) => {
      this.notice = res;
    });
  }

  setOrderList(order: "a-z" | "z-a" | "data") {
    this.orderList = order;
    this.getNoticeItems();
  }

  search(event: any) {
    if (event.keyCode == 13) {
      this.getNoticeItems();
    }
  }

  update(noticeItem) {
    this.noticeItemSelected = noticeItem;
    this.noticeItemForm.patchValue({
      ...noticeItem,
      dual: (noticeItem.dual == 1 || noticeItem.dual === "1") ? 1 : 'null'
    });
    this.fileSelected = noticeItem.image;
    this.fileSelected.background = JSON.parse(this.fileSelected.background);
    this.fileSelected.background = this.fileSelected!.background!.background;
    $("#projeto").modal();
  }

  postForm(): void {
    const form = this.noticeItemForm;

    if (!form.valid) {
      return;
    }
    const noticeItem = form.value; //new NoticeItem(null, form.value.title, form.value.description, this.fileSelected);
    if (noticeItem.dual === 'null' || noticeItem.dual == null) {
      noticeItem.dual = null;
    } else {
      noticeItem.dual = Number(noticeItem.dual);
    }
    if (this.fileSelected) {
      noticeItem.image = JSON.stringify(this.fileSelected);
    }
    noticeItem.notice_id = this.id;
    this.persiste(noticeItem);
  }

  persiste(noticeItem) {
    if (this.noticeItemSelected) {
      noticeItem.id = this.noticeItemSelected.id;
    }
    this._noticeItemService.persist(noticeItem).subscribe((res) => {
      if (!this.noticeItemSelected) {
        noticeItem.id = res.data.id;
        if (!noticeItem.banner) {
          const image = JSON.parse(noticeItem.image);
          noticeItem.banner = image.background;
        }
        this.noticeItemsArray.unshift(noticeItem);
      } else {
        const item = this.noticeItemsArray.find((resItem) => {
          return resItem.id === this.noticeItemSelected.id;
        });
        const index = this.noticeItemsArray.indexOf(item);
        noticeItem.image = JSON.parse(noticeItem.image);
        this.noticeItemsArray[index] = noticeItem;
      }
      this.closeModal();
      console.log("[persiste]", noticeItem);

    });
  }

  private insert(noticeItem): void {
    this._noticeItemService.persist(noticeItem).subscribe((res) => {
      noticeItem.id = res.data.id;
      this.noticeItemsArray.unshift(noticeItem);
      this.closeModal();
    });
  }

  closeModal() {
    this.noticeItemSelected = null;
    this.fileSelected = {
      background: "../../assets/img/image_placeholder.jpg",
    };
    this.noticeItemForm.reset({
      dual: 'null'
    });
    $("#projeto").modal("hide");
  }

  delete(noticeItem): void {
    const component = this;

    Swal.fire({
      title: "Você quer apagar o item?",
      text: "Você não poderá reverter essa ação depois de confirmado",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then(
      (result) => {
        if (result.value) {
          const index = component.noticeItemsArray.indexOf(noticeItem);
          component.noticeItemsArray.splice(index, 1);

          this._noticeItemService.delete(noticeItem.id).subscribe((res) => {
            console.log(res);
          });
        }
      },
      (cancel) => { }
    );
  }

  public getNoticeItems(): void {
    this._noticeItemService
      .collection(this.id, this.inputSearch, this.orderList)
      .then((res: any) => {
        if (res.length > 0) {
          // this.router.navigate(["edital/etapas", res[0].id]);
        }
        for (let i = 0; i < res.length; i++) {
          /** Tirando dado do Padrão antigo **/

          if (res[i].image && res[i].image.substr(0, 2) != "{}") {
            const image = JSON.parse(res[i].image);
            res[i].image = {
              background: res[i].image,
            };
            if (res[i].banner == 'background') {
              res[i].banner = image.background;
            }

          } else {
            res[i].image = JSON.parse(res[i].image);
          }
        }
        this.noticeItemsArray = res;
      });
  }

  showFileManager(imgField) {
    this.imgField = imgField;
    this.appFileManager.showModal();
  }

  uploadSubmited(event: any) {

    if (event.data) {
      this.fileSelected[this.imgField] = event.data.url;
    } else {

      this.fileSelected[this.imgField] = event.url;
    }
    this.imgField = null;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/edital/items/items.component.ts